var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "h-[500px] overflow-y-auto" },
      [
        _c(
          "el-form",
          {
            ref: "pram",
            attrs: { model: _vm.pram, "label-width": "75px" },
            nativeOn: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v(" 债权抵扣比例分档"),
            ]),
            _vm.isCreate !== 2
              ? _c(
                  "div",
                  { staticClass: "mt-8 mb-8" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-plus",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addorReduce(_vm.pram.debtDeductionRatios)
                          },
                        },
                      },
                      [_vm._v("新增分档")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-row",
              _vm._l(_vm.pram.debtDeductionRatios, function (value, index) {
                return _c(
                  "el-col",
                  { key: index + "debtDeductionRatios", attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "第" + (index + 1) + "档",
                          "label-width": "50px",
                          prop: "platformServiceFee",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center justify-center" },
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  readonly: _vm.isCreate === 2,
                                  type: "number",
                                  placeholder: "比例分档",
                                },
                                model: {
                                  value: _vm.pram.debtDeductionRatios[index],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pram.debtDeductionRatios,
                                      index,
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "pram.debtDeductionRatios[index]",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                            _vm.isCreate !== 2
                              ? _c("i", {
                                  staticClass:
                                    "el-icon-remove ml-4 cursor-pointer text-24",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addorReduce(
                                        _vm.pram.debtDeductionRatios,
                                        index
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v(" 债务化债比例分档"),
            ]),
            _vm.isCreate !== 2
              ? _c(
                  "div",
                  { staticClass: "mt-8 mb-8" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-plus",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addorReduce(
                              _vm.pram.debtResolutionRatios
                            )
                          },
                        },
                      },
                      [_vm._v("新增分档")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-row",
              _vm._l(_vm.pram.debtResolutionRatios, function (value, index) {
                return _c(
                  "el-col",
                  { key: index + "debtResolutionRatios", attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "第" + (index + 1) + "档",
                          "label-width": "50px",
                          prop: "platformServiceFee",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center justify-center" },
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  readonly: _vm.isCreate === 2,
                                  type: "number",
                                  placeholder: "比例分档",
                                },
                                model: {
                                  value: _vm.pram.debtResolutionRatios[index],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pram.debtResolutionRatios,
                                      index,
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "pram.debtResolutionRatios[index]",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                            _vm.isCreate !== 2
                              ? _c("i", {
                                  staticClass:
                                    "el-icon-remove ml-4 cursor-pointer text-24",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addorReduce(
                                        _vm.pram.debtResolutionRatios,
                                        index
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v(" 返现比例分档"),
            ]),
            _vm.isCreate !== 2
              ? _c(
                  "div",
                  { staticClass: "mt-8 mb-8" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-plus",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addorReduce(_vm.pram.cashbackRatios)
                          },
                        },
                      },
                      [_vm._v("新增分档")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-row",
              _vm._l(_vm.pram.cashbackRatios, function (value, index) {
                return _c(
                  "el-col",
                  { key: index + "cashbackRatios", attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "第" + (index + 1) + "档",
                          "label-width": "50px",
                          prop: "platformServiceFee",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center justify-center" },
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  readonly: _vm.isCreate === 2,
                                  type: "number",
                                  placeholder: "比例分档",
                                },
                                model: {
                                  value: _vm.pram.cashbackRatios[index],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pram.cashbackRatios,
                                      index,
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "pram.cashbackRatios[index]",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                            _vm.isCreate !== 2
                              ? _c("i", {
                                  staticClass:
                                    "el-icon-remove ml-4 cursor-pointer text-24",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addorReduce(
                                        _vm.pram.cashbackRatios,
                                        index
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v(" 返现金券比例分档"),
            ]),
            _vm.isCreate !== 2
              ? _c(
                  "div",
                  { staticClass: "mt-8 mb-8" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-plus",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addorReduce(
                              _vm.pram.couponCashbackRatios
                            )
                          },
                        },
                      },
                      [_vm._v("新增分档")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-row",
              _vm._l(_vm.pram.couponCashbackRatios, function (value, index) {
                return _c(
                  "el-col",
                  { key: index + "couponCashbackRatios", attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "第" + (index + 1) + "档",
                          "label-width": "50px",
                          prop: "platformServiceFee",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center justify-center" },
                          [
                            _c(
                              "el-input",
                              {
                                attrs: {
                                  readonly: _vm.isCreate === 2,
                                  type: "number",
                                  placeholder: "比例分档",
                                },
                                model: {
                                  value: _vm.pram.couponCashbackRatios[index],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pram.couponCashbackRatios,
                                      index,
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "pram.couponCashbackRatios[index]",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("%"),
                                ]),
                              ],
                              2
                            ),
                            _vm.isCreate !== 2
                              ? _c("i", {
                                  staticClass:
                                    "el-icon-remove ml-4 cursor-pointer text-24",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addorReduce(
                                        _vm.pram.couponCashbackRatios,
                                        index
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v(" 适配范围设置"),
            ]),
            _vm.isCreate !== 2
              ? _c(
                  "div",
                  { staticClass: "flex items-center mb-4 " },
                  [
                    _c("span", [_vm._v("选择会员卡：")]),
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择" },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.selectValue,
                          callback: function ($$v) {
                            _vm.selectValue = $$v
                          },
                          expression: "selectValue",
                        },
                      },
                      _vm._l(_vm.memberCards, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label: item.cardName + "-" + item.code,
                            value: item.id,
                          },
                        })
                      }),
                      1
                    ),
                    _c("span", { staticClass: "pl-8 text-red-500" }, [
                      _vm._v(
                        "范围为非必须项，如果没有设置范围，改配置即为全局配置"
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.pram.memberCards,
                  size: "small",
                  sortable: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", width: "50" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "会员卡编号",
                    prop: "code",
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "会员卡名称",
                    prop: "cardName",
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "会员身份",
                    prop: "memberIdentity",
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "状态", prop: "status", "min-width": "50" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.status === 0 ? "正常" : "禁用") +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.isCreate !== 2
                  ? _c("el-table-column", {
                      attrs: { label: "操作", width: "50", fixed: "right" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: { title: "确认移除该会员卡吗？" },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.removeRow(scope.$index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "platform:admin:role:update",
                                            ],
                                            expression:
                                              "['platform:admin:role:update']",
                                          },
                                        ],
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [_vm._v("移除")]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1808792590
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "dialog-footer-inner mt-14",
        attrs: { slot: "footer" },
        slot: "footer",
      },
      [
        _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
        _vm.isCreate !== 2
          ? _c(
              "el-button",
              {
                directives: [
                  {
                    name: "hasPermi",
                    rawName: "v-hasPermi",
                    value: [
                      "platform:admin:role:update",
                      "platform:admin:role:save",
                    ],
                    expression:
                      "['platform:admin:role:update', 'platform:admin:role:save']",
                  },
                ],
                attrs: { type: "primary" },
                on: { click: _vm.handlerSubmit },
              },
              [_vm._v(" " + _vm._s(_vm.isCreate === 0 ? "确定" : "更新"))]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }